module.exports = __webpack_public_path__ + "static/media/project1.e85b2598.png";